const PROJECT_PATH_PATTERN = /\/project\/([^/]+)/;

export function getProjectIdFromPath(pathname) {
    return pathname.match(PROJECT_PATH_PATTERN)?.[1] ?? null;
}

export function replaceProjectIdInPath(pathname, projectId) {
    if (!PROJECT_PATH_PATTERN.test(pathname)) {
        return pathname;
    }

    return pathname.replace(PROJECT_PATH_PATTERN, `/project/${projectId}`);
}

export function isProjectReportRouteAvailable(route, project, hasReport, hasSensitiveMetric) {
    return hasReport(route.report, project)
        && (route.show ?? true)
        && (route.requiresSensitiveMetric === undefined
            || hasSensitiveMetric(route.requiresSensitiveMetric, project));
}
